import { render, staticRenderFns } from "./goodsTypeList.vue?vue&type=template&id=c154858e&scoped=true&"
import script from "./goodsTypeList.vue?vue&type=script&lang=js&"
export * from "./goodsTypeList.vue?vue&type=script&lang=js&"
import style0 from "./goodsTypeList.vue?vue&type=style&index=0&id=c154858e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c154858e",
  null
  
)

export default component.exports